import DeviceFirmwarePage from "./DeviceFirmwarePage";
import { DataGridSettingsProvider } from "@/components/DataGridSettingsProvider";
import { ModalProvider } from "@/components/ModalProvider";
import { PresetProvider } from "@/components/PresetProvider";
import { presetSelectionKey } from "@/constants/PageType";

export function DeviceFirmwarePageWrapper() {
  return (
    <PresetProvider selectionKey={presetSelectionKey("deviceFirmware")}>
      <DataGridSettingsProvider pageType="deviceFirmware">
        <ModalProvider>
          <DeviceFirmwarePage />
        </ModalProvider>
      </DataGridSettingsProvider>
    </PresetProvider>
  );
}
